import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ToolbarModule } from 'primeng/toolbar';
import { DividerModule } from 'primeng/divider';
import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ChipModule } from 'primeng/chip';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { ActionbarComponent } from './components/actionbar/actionbar.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ConnectionService } from './services/connection/connection.service';
import { SingleSelectDropdownComponent } from './components/single-select-dropdown/single-select-dropdown.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { FilterComponent } from './components/filter/filter.component';
import { TaskInfoFormatterService } from './services/task-info/task-info-formatter.service';
import { ResponseDataFormatService } from './services/format/response-data-format.service';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { NgxBarcode6 } from 'ngx-barcode6';
import { CommonService } from './services/common/common.service';
import { DateFormatPipe } from './pipe/date-format-pipe/date-format.pipe';
import { MenuModule } from 'primeng/menu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { KpiRouteStatePipe } from './pipe/kpi-route-state/kpi-route-state.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { KpicountPipePipe } from './pipe/taskbank-footer/kpicount-pipe.pipe';
import { TaskStatePipe } from './pipe/task-state-pipe/task-state-pipe';
import { CreateRouteComponent } from './components/create-route/create-route.component';
import { TagModule } from 'primeng/tag';

import { TaskSelectPipe } from './pipe/task-select/task-select-pipe.pipe';
import { AngularSplitModule } from 'angular-split';
import { TaskBankComponent } from '../modules/home/dashboard/task-bank/task-bank.component';
import { UnplannedComponent } from '../modules/home/dashboard/task-bank/unplanned/unplanned.component';
import { UnloadedComponent } from '../modules/home/dashboard/task-bank/unloaded/unloaded.component';
import { PlannedPbmComponent } from '../modules/home/dashboard/task-bank/planned-pbm/planned-pbm.component';
import { PlannedComponent } from '../modules/home/dashboard/task-bank/planned/planned.component';
import { MessageModule } from 'primeng/message';
import { InputNumberModule } from 'primeng/inputnumber';
import { UpdateAddressComponent } from './components/add-address/update-address.component';
import { AddressDetailsComponent } from './components/address-details/address-details.component';
import { ErrorWindowComponent } from './components/error-window/error-window.component';
import { RouteItemDetailsComponent } from './components/route-item-details/route-item-details.component';

import { ItemDetailsComponent } from '../modules/home/dashboard/task-bank/item-details/item-details.component';
import { PushToCloudComponent } from '../modules/home/dashboard/task-bank/push-to-cloud/push-to-cloud.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ShowVehicleIconPipe } from './pipe/map-view/show-vehicle-icon.pipe';
import { UpdateStateFormComponent } from './components/update-state-form/update-state-form.component';
import { UpdateStateComponent } from '../modules/home/dashboard/task-bank/update-state/update-state.component';
import { NotificationPopUpComponent } from './components/notification-pop-up/notification-pop-up.component';
import { ImageGalleryComponent } from './components/image-gallery/image-gallery.component';
import { GalleriaModule } from 'primeng/galleria';
import { KpiProgressPipe } from './pipe/kpi-progress/kpi-progress.pipe';
import { TaskMovementComponent } from '../modules/home/dashboard/task-movement/task-movement.component';
import { MapLeafletComponent } from '../modules/map-leaflet/component/mapLeaflet.component';
import { RouteListComponent } from '../modules/landing/route-list/route-list.component';
import { MergeTaskDialogComponent } from '../modules/landing/route-list/merge-task-dialog/merge-task-dialog.component';
import { RoutePanelComponent } from '../modules/map-leaflet/component/route-panel-component/route-panel.component';
import { RouteOptimizationComponent } from '../modules/home/dashboard/route-optimization/route-optimization.component';
import { UpdateManagerNotesComponent } from './components/update-manager-notes/update-manager-notes.component';
import { DpInfoComponent } from '../modules/dp-info/dp-info.component';
import { DriverStatusPipe } from './pipe/driver-status/driver-status.pipe';
import {PickListModule} from 'primeng/picklist'
import { ColumnSettingsComponent } from './components/column-settings/column-settings.component';
import { ColumnPreferenceFormComponent } from './components/column-preference-form/column-preference-form.component';
import { ColumnVisibilityComponent } from './components/column-visibility/column-visibility.component';
import { ColumnService } from './services/column-services/column.service';
import { RemoveUnderscorePipe } from './pipe/utility-pipes/data-formatters/removeUnderscore.pipe';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { PopoverModule } from 'primeng/popover'
import { SelectButtonModule } from 'primeng/selectbutton';
import { MainkpiItemProgressPipe } from './pipe/mainkpi-item/mainkpi-item-progress.pipe';
import { SelectionRowAllowedPipe } from './pipe/row-selection-check/selection-row-allowed.pipe';
import { SearchInputComponent } from './search-input/search-input.component';
import { ColorLegendsComponent } from '../modules/home/dashboard/task-bank/color-legends/color-legends.component';
import { OrderIdColorPipe } from './pipe/OrderIdColor/order-id-color.pipe';
import { SplitButtonModule } from 'primeng/splitbutton';
import { DrawerModule } from 'primeng/drawer';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { ConsequencesDialogComponent } from "../modules/home/dashboard/task-movement/consequences-dialog/consequences-dialog.component";
import { OptimisedSequenceComponent } from '../modules/landing/optimised-sequence/optimised-sequence.component';
import { RoutesFilterComponent } from '../modules/landing/routes-filter/routes-filter.component';
import { MovedInOutDialogComponent } from './components/moved-in-out-dialog/moved-in-out-dialog.component';
import { PlannedAtLoadingDialogComponent } from './components/planned-at-loading-dialog/planned-at-loading-dialog.component';
import { TaskBankFilterComponent } from '../modules/home/dashboard/task-bank/task-bank-filter/task-bank-filter.component';
@NgModule({
  declarations: [
    SideMenuComponent,
    ActionbarComponent,
    LoaderComponent,
    SingleSelectDropdownComponent,
    MultiSelectDropdownComponent,
    FilterComponent,
    UpdateAddressComponent,
    AddressDetailsComponent,
    KpiRouteStatePipe,
    ShowVehicleIconPipe,
    KpicountPipePipe,
    TaskStatePipe,
    SelectionRowAllowedPipe,
    RemoveUnderscorePipe,
    MainkpiItemProgressPipe,
    CreateRouteComponent,
    TaskSelectPipe,
    DateFormatPipe,
    ErrorWindowComponent,
    RouteItemDetailsComponent,
    TaskBankComponent,
    UnplannedComponent,
    UnloadedComponent,
    PlannedPbmComponent,
    ItemDetailsComponent,
    PlannedComponent,
    PushToCloudComponent,
    UpdateStateFormComponent,
    UpdateStateComponent,
    ImageGalleryComponent,
    TaskMovementComponent,
    NotificationPopUpComponent,
    KpiProgressPipe,
    TaskMovementComponent,
    DpInfoComponent,
    UpdateManagerNotesComponent,
    MapLeafletComponent,
    RouteListComponent,
    RoutePanelComponent,
    RouteOptimizationComponent,
    DriverStatusPipe,
    ColumnSettingsComponent,
    ColumnVisibilityComponent,
    ColumnPreferenceFormComponent,
    NavBarComponent,
    SearchInputComponent,
    ColorLegendsComponent,
    OrderIdColorPipe,
    OptimisedSequenceComponent,
    RoutesFilterComponent,
    MovedInOutDialogComponent,
    PlannedAtLoadingDialogComponent,
    TaskBankFilterComponent
    ,StatusBadgeComponent
    ,EmptyStateComponent
  ],
  imports: [
    CommonModule,
    CheckboxModule,
    MessageModule,
    CardModule,
    InputTextModule,
    InputNumberModule,
    ToastModule,
    ConfirmDialogModule,
    TableModule,
    ButtonModule,
    TabsModule,
    ToolbarModule,
    DividerModule,
    DatePickerModule,
    RadioButtonModule,
    TagModule,
    ChipModule,
    FormsModule,
    DialogModule,
    SelectModule,
    NgxBarcode6,
    MultiSelectModule,
    ReactiveFormsModule,
    MenuModule,
    TooltipModule,
    ToggleSwitchModule,
    AutoCompleteModule,
    GalleriaModule,
    AngularSplitModule,
    PickListModule,
    PopoverModule,
    SelectButtonModule,
    SplitButtonModule,
    DrawerModule,
    ConsequencesDialogComponent,
    MergeTaskDialogComponent
],
  exports: [
    CheckboxModule,
    PopoverModule,
    MessageModule,
    CardModule,
    InputTextModule,
    InputNumberModule,
    ToastModule,
    ConfirmDialogModule,
    TableModule,
    ButtonModule,
    TabsModule,
    ToolbarModule,
    DividerModule,
    DatePickerModule,
    RadioButtonModule,
    ChipModule,
    AngularSplitModule,
    PickListModule,
    SelectButtonModule,
    SideMenuComponent,
    ActionbarComponent,
    LoaderComponent,
    SingleSelectDropdownComponent,
    MultiSelectDropdownComponent,
    FilterComponent,
    UpdateAddressComponent,
    AddressDetailsComponent,
    RouteItemDetailsComponent,
    DpInfoComponent,
    DialogModule,
    SelectModule,
    NgxBarcode6,
    FormsModule,
    CommonModule,
    MultiSelectModule,
    ReactiveFormsModule,
    KpiRouteStatePipe,
    ShowVehicleIconPipe,
    MainkpiItemProgressPipe,
    MenuModule,
    TooltipModule,
    KpicountPipePipe,
    TaskStatePipe,
    SelectionRowAllowedPipe,
    CreateRouteComponent,
    TaskSelectPipe,
    DateFormatPipe,
    AngularSplitModule,
    TaskBankComponent,
    UnplannedComponent,
    UnloadedComponent,
    PlannedPbmComponent,
    ItemDetailsComponent,
    PlannedComponent,
    ToggleSwitchModule,
    PushToCloudComponent,
    UpdateStateFormComponent,
    UpdateStateComponent,
    GalleriaModule,
    TaskMovementComponent,
    NotificationPopUpComponent,
    KpiProgressPipe,
    TaskMovementComponent,
    UpdateManagerNotesComponent,
    MapLeafletComponent,
    RouteListComponent,
    RoutePanelComponent,
    RouteOptimizationComponent,
    ColumnSettingsComponent,
    ColumnPreferenceFormComponent,
    ColumnVisibilityComponent,
    TaskBankFilterComponent,
    DriverStatusPipe,
    RemoveUnderscorePipe,
    NavBarComponent,
    SearchInputComponent,
    ColorLegendsComponent,
    OrderIdColorPipe,
    SplitButtonModule,
    TagModule,
    OptimisedSequenceComponent,
    TagModule,
    RoutesFilterComponent,
    MovedInOutDialogComponent,
    PlannedAtLoadingDialogComponent
    ,StatusBadgeComponent
    ,EmptyStateComponent
    ,DrawerModule
  ],
  providers: [
    ConnectionService,
    TaskInfoFormatterService,
    TitleCasePipe,
    ResponseDataFormatService,
    ColumnService,
    CommonService,
    DateFormatPipe,
    TaskSelectPipe,
    MainkpiItemProgressPipe
  ]
})
export class SharedModule { }
